import React from "react";
import { MagnifyingGlass } from "@phosphor-icons/react";

const SearchBar = ({ textQuery, setTextQuery }) => {
  return (
    <div className="flex flex-row items-center justify-between gap-[12px]">
      <div className="input-group-area flex flex-row gap-[12px] h-[45px] px-[12px] border bg-white rounded-[8px] w-full">
        <input
          type="text"
          maxLength={3000}
          className="my-auto focus:!border-0 focus:!shadow-none form-control border-0 text-[#B3B3B3]"
          placeholder="Search conversations"
          value={textQuery}
          onChange={(e) => setTextQuery(e.target.value)}
        />
        <div className="button-box align-baseline flex gap-[12px] my-auto">
          <MagnifyingGlass size={16} />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
